/*
* @providesModule WithdrawalSuccessModal
* 
*/

import React from 'react';

import ConfettiView from 'ConfettiView';
import HeaderModal from 'HeaderModal';
import Label from 'Label';
import I18n from 'INTL';
import styles from 'WithdrawalSuccessModalStyle';
import PushButton from 'PushButton';
import SkillzImage from 'SkillzImage';
import SkillzStyle from 'SkillzStyle';
import PropTypes from 'prop-types';

import {
  View,
  StyleSheet,
} from 'react-native';

const {
  btnGradientOne,
  viewCornerRadiusSecondary,
  tabHighlightColor,
} = SkillzStyle.fullStyles;

export default class WithdrawalSuccessModal extends React.PureComponent {

  static propTypes = {
    title: PropTypes.string,
    bodyText: PropTypes.string,
    numberOfLines: PropTypes.number,
    onDone: PropTypes.func,
  };

  static defaultProps = {
    onDone: () => { /* */ },
  };

  _onOkPress = () => {
    this.props.onDone();
  }

  _renderContent(): React.ReactNode {
    return (
      <View style={styles.contentContainer}>
        <SkillzImage style={styles.successModalIcon}
                     source={'ic_check_icon_skz.png'}
                     color={tabHighlightColor.color}
                     resizeMode={'contain'} />
        <Label style={styles.bodyText}
               numberOfLines={this.props.numberOfLines}>
          {this.props.bodyText}
        </Label>
        <PushButton style={styles.okButton}
                    colors={btnGradientOne}
                    cornerRadius={viewCornerRadiusSecondary.borderRadius}
                    title={I18n.message('OK')}
                    textStyle={styles.okButtonText}
                    onPress={this._onOkPress} />
      </View>
    );
  }

  render(): React.ReactNode {
    return (
      <HeaderModal title={this.props.title}
                   displayConfettiFrontShadow
                   onDone={this._onOkPress}>
        {this._renderContent()}
      </HeaderModal>
    );
  }
}
